import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './shareimg.routes';
import addHtml from './modal/add.html';
import _ from 'lodash';


export class ShareImgController {
    $http;
    socket;
    awesomeThings = [];
    shareimg = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;

        this.languageTypes = [
            { value: 'pt', name: '葡语' },
            { value: 'en', name: '英语' },
            { value: 'es', name: '西语' }
        ]

    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/share_imgs/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.shareimgs = response.data.data;
                        this.socket.syncUpdates('shareimgs', this.shareimgs);
                    }

                });


            this.getTypeName = function (value) {
                var ret = _.find(this.languageTypes, { value: value });
                if (ret) {
                    return ret.name;
                }
                return '';
            }

        } else {
            this.$location.path('main')
        }
    }


    search() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/share_imgs/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': this.currentPage - 1,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.shareimgs = response.data.data;

                        this.socket.syncUpdates('shareimgs', this.shareimgs);
                    }
                });
        } else {
            this.$location.path('main')
        }


    }



    addShareImg() {
        const shareimgs = this.shareimgs;

        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                $scope.vm = {};

                $scope.languageTypes = [
                    { value: 'pt', name: '葡语' },
                    { value: 'en', name: '英语' },
                    { value: 'es', name: '西语' }
                ]
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;


                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/share_imgs/9528/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/share_imgs/9529/',
                    method: 'POST',
                    autoUpload: true,
                });




                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });

                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            $scope.isloadcoversmallError = true;
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            return false;
                        }

                    }
                });


                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        $scope.vm.small_img = response.data.small_img;
                    }
                };

                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }

                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.max_img = response.data.max_img;

                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }


                $scope.save = function (myForm) {

                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        console.log($scope.vm);
                        $http.post('/api/share_imgs/', $scope.vm).then((response) => {
                            console.log(response.data.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (data) {
                if (data) {
                    shareimgs.push(data);
                }
            }, function () {
            });
    }


    editShareImg(item, index) {
        const shareimgs = this.shareimgs;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                $scope.vm = angular.copy(item);
                $scope.languageTypes = [
                    { value: 'pt', name: '葡语' },
                    { value: 'en', name: '英语' },
                    { value: 'es', name: '西语' }
                ]
                // $scope.isload = false;
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;


                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/share_imgs/9528/',
                    method: 'POST',
                    autoUpload: true,
                });

                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/share_imgs/9529/',
                    method: 'POST',
                    autoUpload: true,
                });




                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });

                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            $scope.isloadcoversmallError = true;
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            return false;
                        }

                    }
                });


                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        $scope.vm.small_img = response.data.small_img;

                    }
                };

                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }

                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        $scope.vm.max_img = response.data.max_img;

                    }
                };

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }




                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        console.log($scope.vm);
                        $http.put('/api/share_imgs/' + item._id + '/', $scope.vm).then((response) => {
                            console.log(response);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    shareimgs[index] = ret;
                }
            }, function () {
            });
    }



    deleteShareImg(item, index) {
        this.$http.delete('/api/share_imgs/' + item._id + '/').then(response => {
            if (response.status === 200) {
                this.shareimgs.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.shareimg', [uiRouter])
    .config(routing)
    .component('shareimg', {
        template: require('./shareimg.html'),
        controller: ShareImgController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/shareimg/shareimg.component.js